import { For, Show } from "solid-js";
import { Icon } from "~/ui/Icon";
import type { TreeData } from "./today";

const levelNames = ["Keim", "Schlupf", "Entdecker", "Neugierig", "Wachsend", "Stärker", "Entwickelt", "Bereit", "Legendär", "Unaufhaltbar", "Superheld"];
const layerManifest: Record<number, { float: number; star: number; dust: boolean }> = {
  0: { float: 1, star: 9, dust: true }, 1: { float: 1, star: 5, dust: true },
  2: { float: 1, star: 7, dust: true }, 3: { float: 2, star: 5, dust: true },
  4: { float: 1, star: 7, dust: true }, 5: { float: 1, star: 6, dust: true },
  6: { float: 2, star: 5, dust: true }, 7: { float: 1, star: 6, dust: true },
  8: { float: 2, star: 6, dust: true }, 9: { float: 2, star: 24, dust: true },
  10: { float: 5, star: 11, dust: true }
};

function TreeLayers(props: { level: number; name: string }) {
  const base = () => `/img/tree-levels/level-${props.level}/`;
  const manifest = () => layerManifest[props.level] ?? layerManifest[0];
  const animation = () => props.level >= 7 ? "anim-float" : props.level === 0 ? "" : "anim-sway";
  return (
    <div class="monster-layers">
      <Show when={manifest().dust}><img src={`${base()}dust.png`} class="monster-layer layer-dust" alt="" /></Show>
      <For each={Array.from({ length: manifest().float }, (_, index) => index + 1)}>{(index) =>
        <img src={`${base()}float-${index}.png`} class={`monster-layer layer-float layer-float-${index}`} alt="" />
      }</For>
      <For each={Array.from({ length: manifest().star }, (_, index) => index + 1)}>{(index) =>
        <img src={`${base()}star-${index}.png`} class={`monster-layer layer-star layer-star-${index}`} alt="" />
      }</For>
      <img src={`${base()}body.png`} class={`monster-layer layer-body ${animation()}`} alt={props.name} />
    </div>
  );
}

export function CommunityTreeCard(props: { value: TreeData | null; showStats?: boolean }) {
  const level = () => Math.max(0, Math.min(10, props.value?.tree_level ?? 0));
  const name = () => levelNames[level()] ?? "Keim";
  const progress = () => Math.max(0, Math.min(100, props.value?.progress_percent ?? 0));
  return (
    <div class="card" style={{ "min-width": 0 }}>
      <h3 style={{ "margin-bottom": "16px" }}><Icon name="tree" style={{ width: "16px", height: "16px" }} /> Unser Klassenbaum</h3>
      <Show when={props.value} fallback={<div style={{ display: "flex", "justify-content": "center", padding: "20px" }}><div class="loading-spinner" /></div>}>
        <div style={{ "text-align": "center" }}>
          <div class="monster-stage tree-stage"><TreeLayers level={level()} name={name()} /></div>
          <div style={{ "font-weight": 800, "font-size": "1rem", color: "var(--ink)", margin: "8px 0 2px" }}>{name()} · Level {level()}</div>
          <div style={{ "font-size": "0.8rem", color: "var(--text-muted)", "margin-bottom": "10px" }}>🌱 {props.value?.tree_points ?? 0} Punkte diese Woche</div>
          <div style={{ margin: "0 8px 4px" }}>
            <div style={{ height: "8px", background: "var(--border)", "border-radius": "999px", overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${progress()}%`, background: "var(--lime)", "border-radius": "999px", transition: "width 0.8s ease" }} />
            </div>
          </div>
          <div style={{ "font-size": "0.75rem", color: "var(--text-muted)" }}>
            {level() >= 10 ? "🏆 Maximales Level erreicht!" : <>Noch <strong>{props.value?.points_to_next_level ?? 100}</strong> Punkte bis Level {level() + 1}</>}
          </div>
          <Show when={props.value?.last_week}>{(lastWeek) =>
            <div style={{ "margin-top": "12px", padding: "8px 12px", background: "var(--bg-card)", "border-radius": "10px", border: "2px solid var(--lime)", display: "inline-block" }}>
              <span style={{ "font-size": "0.72rem", color: "var(--ink)", "font-weight": 700 }}>Letzte Woche · 🌳 Level {lastWeek().level_reached} · {lastWeek().points_earned} Punkte</span>
            </div>
          }</Show>
          <Show when={props.showStats !== false}>
            <div style={{ "text-align": "center", "margin-top": "16px", "font-size": "0.72rem", color: "var(--text-muted)" }}>
              <Icon name="sun" style={{ width: "16px", height: "16px" }} /> {props.value?.total_checkins ?? 0} Check-ins · <Icon name="moon" style={{ width: "16px", height: "16px" }} /> {props.value?.total_checkouts ?? 0} Check-outs
            </div>
          </Show>
        </div>
      </Show>
    </div>
  );
}
